export const enumSelectFieldUtils = {
  getFirstEnumValue: (enumValues: string[] | undefined): string => {
    if (!enumValues || enumValues.length === 0) {
      return '';
    }
    return enumValues[0];
  }
};
